module.exports = __webpack_public_path__ + "bv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bv.svg
// module id = 469
// module chunks = 0